import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { connect, Provider, ReactReduxContext } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import DropDownMenu from 'material-ui/DropDownMenu';
import RaisedButton from 'material-ui/RaisedButton';
import MenuItem from 'material-ui/MenuItem';
import Measure from 'react-measure';
import { GrayButton, SecondaryButton, SocialNetworkIcon, Popover, QueueFlyoutTab, Spinner, WatchClickOutside, EmptyState } from 'components';
import { LLChip, LLSubmitButton, LLButton, LLDropDownList } from 'components/FormElements';
import { HorizontalNav } from 'containers';
import { addQueuePostTime, removeQueuePostTime } from 'redux/modules/contentLibraryQueues';
import { removeCategoryFromQueue } from 'redux/modules/queues';
import styles from './QueueFlyout.scss';
import QueueWrapPostCard from './QueueWrapPostCard';
import pluralize from 'pluralize';
import Avatar from 'material-ui/Avatar';
import Chip from 'material-ui/Chip';
var QueueWrap = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    queues: state.queues["".concat(orgId)] || [],
    theme: state.theme,
    loadingQueues: state.queues.loadingQueues,
    createPostTimeError: state.contentLibrary.createPostTimeError,
    addingSAInProgress: state.contentLibrary.addingSAInProgress,
    removingCategory: state.queues.removingCategory
  };
}, {
  addQueuePostTime: addQueuePostTime,
  removeCategoryFromQueue: removeCategoryFromQueue,
  removeQueuePostTime: removeQueuePostTime
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(QueueWrap, _Component);

  var _super = _createSuper(QueueWrap);

  function QueueWrap(props) {
    var _this;

    _classCallCheck(this, QueueWrap);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var hasQueues = !!_this.props.queues.length;

      if (hasQueues) {
        _this.setState({
          selectedQueue: 0
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleTabClick", function (queueIndex) {
      _this.setState({
        selectedQueue: queueIndex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderTabLabel", function (queue) {
      var network = ''; // Wrapping in a try catch just in case we end up with a queue without any social networks

      try {
        network = queue.SocialAccounts[0].platform.split(' ')[0].toLowerCase();
      } catch (e) {
        // TODO: Notify the server that someone's data is somehow messed up.
        network = null;
      }

      var labelTextRaw = queue.SocialAccounts[0].username.toUpperCase();
      var labelText = labelTextRaw.length > 35 ? "".concat(labelTextRaw.substring(0, 32), "...") : labelTextRaw;
      return !network ? null : /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(SocialNetworkIcon, {
        network: network
      }), " ", labelText);
    });

    _defineProperty(_assertThisInitialized(_this), "renderAddTimeDialog", function () {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        style: {
          color: _this.props.theme.colors.gray1
        }
      }, "This will add another piece of content each week to your ".concat(_this.state.selectedQueue !== null && _this.props.queues[_this.state.selectedQueue].SocialAccounts ? _this.props.queues[_this.state.selectedQueue].SocialAccounts[0].username : '', " queue.")), /*#__PURE__*/React.createElement("p", {
        style: {
          color: _this.props.theme.colors.gray1
        }
      }, "What day and time would you like this to post?"), /*#__PURE__*/React.createElement(DropDownMenu, {
        value: _this.state.selectedDayOfWeek,
        onChange: _this.postTimeWeekdaySelected,
        style: {
          marginRight: 24
        }
      }, _this.state.daysOfWeek.map(function (d, idx) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: idx,
          value: idx,
          primaryText: d.title
        });
      })), /*#__PURE__*/React.createElement(DropDownMenu, {
        value: _this.state.selectedTimeOfDay,
        onChange: _this.postTimeOfDaySelected
      }, _this.state.timesOfDay.map(function (d, idx) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: idx,
          value: idx,
          primaryText: d.title
        });
      })), _this.doesSelectedPostTimeExist() && /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red'
        }
      }, "You already have this post time added to your Queue."), _this.state.addingQueuePostTimeError && /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red'
        }
      }, _this.state.addingQueuePostTimeError));
    });

    _defineProperty(_assertThisInitialized(_this), "addQueuePostTime", function () {
      _this.setState({
        isAddingQueuePostTime: true
      });

      _this.props.addQueuePostTime(_this.props.organization.id, _this.props.queues[_this.state.selectedQueue].id, _this.state.daysOfWeek[_this.state.selectedDayOfWeek], _this.state.timesOfDay[_this.state.selectedTimeOfDay]).then(function (res) {
        _this.props.queues[_this.state.selectedQueue].QueuePostTimes.push(res.data);

        _this.setState({
          isAddingQueuePostTime: false,
          showAddTimeDialog: false,
          selectedDayOfWeek: 0,
          selectedTimeOfDay: 0
        });
      })["catch"](function (err) {
        console.error(err);

        _this.setState({
          isAddingQueuePostTime: false,
          addingQueuePostTimeError: err.error.message
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "postTimeOfDaySelected", function (e, index, value) {
      _this.setState({
        selectedTimeOfDay: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "postTimeWeekdaySelected", function (e, index, value) {
      _this.setState({
        selectedDayOfWeek: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "formatPostTimeChipLabel", function (qpt) {
      var day = '';
      var time = '';

      switch (qpt.weekday) {
        case 1:
          day = 'Monday';
          break;

        case 2:
          day = 'Tuesday';
          break;

        case 3:
          day = 'Wednesday';
          break;

        case 4:
          day = 'Thursday';
          break;

        case 5:
          day = 'Friday';
          break;

        case 6:
          day = 'Saturday';
          break;

        case 7:
          day = 'Sunday';
          break;
      }

      switch (qpt.timeOfDay) {
        case 1:
          time = 'Morning';
          break;

        case 2:
          time = 'Afternoon';
          break;

        case 3:
          time = 'Evening';
          break;
      }

      return "".concat(day, " ").concat(time);
    });

    _defineProperty(_assertThisInitialized(_this), "removeQueuePostTime", function (qpt) {
      _this.props.queues[_this.state.selectedQueue].QueuePostTimes.splice(_this.props.queues[_this.state.selectedQueue].QueuePostTimes.indexOf(qpt), 1);

      _this.forceUpdate();

      _this.props.removeQueuePostTime(qpt.id, _this.props.organization.id).then(function () {})["catch"](function (err) {
        console.error(err);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "doesSelectedPostTimeExist", function () {
      if (_this.state.selectedQueue === null) {
        return false;
      }

      var selectedDay = _this.state.daysOfWeek[_this.state.selectedDayOfWeek];
      var selectedTime = _this.state.timesOfDay[_this.state.selectedTimeOfDay];
      var postTimes = _this.props.queues[_this.state.selectedQueue].QueuePostTimes;
      return postTimes.some(function (pt) {
        return pt.timeOfDay === selectedTime.id && pt.weekday === selectedDay.id;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "deleteQueueFromChannel", function () {
      console.log('in deleteQueueFromChannel');
      console.log(_this.state.selectedQueue);

      _this.props.removeCategoryFromQueue(_this.props.organization.id, [_this.props.queues[_this.state.selectedQueue].SocialAccounts[0].id], _this.state.categoryToRemove.id, _this.props.queues[_this.state.selectedQueue].id).then(function () {
        _this.setState({
          showRemoveCategoryDialog: false
        });
      });
    });

    _this.state = {
      categoryToRemove: {
        tagName: ''
      },
      showRemoveCategoryDialog: false,
      selectedQueue: props.selectedQueue ? props.selectedQueue : 0,
      selectedDayOfWeek: 0,
      selectedTimeOfDay: 0,
      isAddingQueuePostTime: false,
      addingQueuePostTimeError: false,
      showAddTimeDialog: false,
      daysOfWeek: [{
        id: 7,
        title: 'Sunday'
      }, {
        id: 1,
        title: 'Monday'
      }, {
        id: 2,
        title: 'Tuesday'
      }, {
        id: 3,
        title: 'Wednesday'
      }, {
        id: 4,
        title: 'Thursday'
      }, {
        id: 5,
        title: 'Friday'
      }, {
        id: 6,
        title: 'Saturday'
      }],
      timesOfDay: [{
        id: 1,
        title: 'Morning'
      }, {
        id: 2,
        title: 'Afternoon'
      }, {
        id: 3,
        title: 'Evening'
      }]
    };
    return _this;
  }

  _createClass(QueueWrap, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var hasQueues = !!this.props.queues.length;
      var addTimeActions = [function (ctx) {
        return /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, ' ', /*#__PURE__*/React.createElement(GrayButton, {
          label: "Cancel",
          theme: _this2.props.theme,
          style: {
            marginRight: 24
          },
          onClick: function onClick() {
            return _this2.setState({
              showAddTimeDialog: false,
              selectedDayOfWeek: 0,
              selectedTimeOfDay: 0,
              isAddingQueuePostTime: false,
              addingQueuePostTimeError: false
            });
          }
        }));
      }, function (ctx) {
        return /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, ' ', /*#__PURE__*/React.createElement(SecondaryButton, {
          theme: _this2.props.theme,
          disabled: _this2.state.isAddingQueuePostTime || _this2.doesSelectedPostTimeExist(),
          label: "Add",
          onClick: _this2.addQueuePostTime
        }));
      }];
      var postTimeChips = this.state.selectedQueue !== null && this.props.queues[this.state.selectedQueue].QueuePostTimes ? this.props.queues[this.state.selectedQueue].QueuePostTimes.map(function (qpt, idx) {
        return /*#__PURE__*/React.createElement(LLChip, {
          key: idx,
          theme: _this2.props.theme,
          label: _this2.formatPostTimeChipLabel(qpt),
          style: {
            marginRight: 18
          },
          onRequestDelete: function onRequestDelete() {
            _this2.removeQueuePostTime(qpt, _this2.props.organization.id);
          }
        });
      }) : null; // sort postTimeChips by day and/or time

      if (postTimeChips) {
        var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        var timeNames = ['Morning', 'Afternoon', 'Evening'];
        postTimeChips = postTimeChips.sort(function (a, b) {
          var aDayName = a.props.label.split(' ')[0];
          var bDayName = b.props.label.split(' ')[0];
          var aTimeName = a.props.label.split(' ')[1];
          var bTimeName = b.props.label.split(' ')[1];

          if (aDayName === bDayName) {
            console.log('dayNames are equal');
            console.log(aTimeName);
            console.log(bTimeName);
            return timeNames.indexOf(aTimeName) > timeNames.indexOf(bTimeName);
          }

          return dayNames.indexOf(aDayName) > dayNames.indexOf(bDayName);
        });
      }

      var categoryChips = (this.props.queues[this.state.selectedQueue] && this.props.queues[this.state.selectedQueue].PostTemplateTags ? this.props.queues[this.state.selectedQueue].PostTemplateTags : []).map(function (tag) {
        return /*#__PURE__*/React.createElement(Chip, {
          key: tag.id,
          onRequestDelete: function onRequestDelete() {
            _this2.setState({
              categoryToRemove: tag,
              showRemoveCategoryDialog: true
            });
          },
          className: styles.categoryChip
        }, !!tag.avatarImageUrl && /*#__PURE__*/React.createElement(Avatar, {
          src: tag.avatarImageUrl
        }), tag.tagName);
      });
      var removeAccountActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        onClick: function onClick() {
          return _this2.setState({
            showRemoveCategoryDialog: false
          });
        },
        style: {
          margin: 8,
          marginTop: 24
        },
        disabled: this.props.unfavoriting
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        disabled: this.props.removingCategory || this.props.addingSAInProgress,
        label: this.props.deletingAccountLink ? /*#__PURE__*/React.createElement("i", {
          className: "fa fa-spin fa-spinner",
          style: {
            fontSize: 20
          }
        }) : 'Remove',
        onClick: function onClick() {
          _this2.deleteQueueFromChannel();
        },
        style: {
          margin: 8,
          marginTop: 24
        }
      })];
      return /*#__PURE__*/React.createElement("div", {
        style: {
          height: '100%'
        }
      }, this.props.showTabs && /*#__PURE__*/React.createElement("div", {
        className: styles.tabs,
        style: {
          marginTop: 0
        }
      }, this.props.queues.map(function (queue, index) {
        return /*#__PURE__*/React.createElement(QueueFlyoutTab, {
          isSelected: _this2.state.selectedQueue !== null && _this2.props.queues[_this2.state.selectedQueue].id === queue.id,
          label: _this2.renderTabLabel(queue),
          key: index,
          onClick: function onClick() {
            return _this2.handleTabClick(index);
          }
        });
      })), this.state.selectedQueue !== null && this.props.queues[this.state.selectedQueue].Posts.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: styles.postTimeSection,
        style: this.props.showTabs ? {
          marginLeft: 0,
          paddingLeft: 36
        } : {}
      }, /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          margin: 0
        }
      }, postTimeChips && postTimeChips.length > 0 && /*#__PURE__*/React.createElement("span", {
        className: styles.postTimeHeader
      }, "Post ".concat(pluralize('Time', postTimeChips.length), ":")), postTimeChips && postTimeChips.length > 0 ? postTimeChips : /*#__PURE__*/React.createElement("p", {
        style: {
          color: this.props.theme.colors.gray1,
          margin: '5px 0'
        }
      }, "Content in this Queue will not be posted until you add a Post Time.", ' ', /*#__PURE__*/React.createElement("a", {
        style: {
          cursor: 'pointer',
          color: this.props.theme.colors.primaryColor,
          textDecoration: 'underline'
        },
        onClick: function onClick() {
          return _this2.setState({
            showAddTimeDialog: true
          });
        }
      }, "Add one now.")), postTimeChips && postTimeChips.length > 0 && postTimeChips.length < 5 && /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-plus ".concat(styles.addBtn),
        onClick: function onClick() {
          return _this2.setState({
            showAddTimeDialog: true
          });
        }
      }))), !!categoryChips && categoryChips.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: styles.postTimeSection,
        style: this.props.showTabs ? {
          marginLeft: 0,
          paddingLeft: 36
        } : {}
      }, /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          margin: 0,
          marginTop: 10
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.postTimeHeader
      }, "".concat(pluralize('Category', categoryChips.length), ":")), categoryChips)), this.props.loadingQueues ? /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })) : this.state.selectedQueue !== null && /*#__PURE__*/React.createElement("div", {
        style: {
          overflowX: 'hidden',
          overflowY: 'auto',
          height: 'calc(100% - 187px)',
          width: '100%'
        }
      }, this.props.queues[this.state.selectedQueue].Posts.length ? this.props.queues[this.state.selectedQueue].Posts.map(function (post, index) {
        return /*#__PURE__*/React.createElement(QueueWrapPostCard, {
          key: index,
          post: post,
          network: _this2.state.selectedQueue !== null && _this2.props.queues[_this2.state.selectedQueue].SocialAccounts && _this2.props.queues[_this2.state.selectedQueue].SocialAccounts.length ? _this2.props.queues[_this2.state.selectedQueue].SocialAccounts[0].platform : ''
        });
      }) : /*#__PURE__*/React.createElement("div", null, this.props.queues[this.state.selectedQueue].PostTemplateTags.length === 0 ? /*#__PURE__*/React.createElement(EmptyState, {
        buttonLabel: "Add some categories now",
        buttonOnClick: function buttonOnClick() {
          _this2.props.router.push("/org/".concat(_this2.props.organization.id, "/content"));
        },
        text: "Your Queue is not Subscribed to any Content",
        iconName: "fa fa-calendar-minus-o",
        iconSize: "95px",
        style: {
          marginTop: 24
        }
      }) : /*#__PURE__*/React.createElement(EmptyState, {
        buttonLabel: "Add some posts now",
        buttonOnClick: function buttonOnClick() {
          _this2.props.router.push("/org/".concat(_this2.props.organization.id, "/content"));
        },
        text: "Your Queue is Empty",
        iconName: "fa fa-calendar-minus-o",
        iconSize: "95px",
        style: {
          marginTop: 24
        }
      })), /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (ctx) {
        return /*#__PURE__*/React.createElement(Dialog, {
          actions: addTimeActions.map(function (f) {
            return f(ctx);
          }),
          open: _this2.state.showAddTimeDialog,
          title: "Add A Post Time",
          onRequestClose: function onRequestClose() {
            return _this2.setState({
              showAddTimeDialog: false
            });
          }
        }, _this2.renderAddTimeDialog());
      })), /*#__PURE__*/React.createElement(Dialog, {
        actions: removeAccountActions,
        open: this.state.showRemoveCategoryDialog,
        title: "Remove All ".concat(this.state.categoryToRemove.tagName, " Content?")
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        style: {
          color: '#616161'
        }
      }, "This will remove ".concat(this.state.categoryToRemove.tagName, " content from your queue and also\n                      suspend the addition of new pieces of content.")), /*#__PURE__*/React.createElement("p", {
        style: {
          color: '#616161'
        }
      }, "You can still select individual pieces of content from the ", this.state.categoryToRemove.tagName, " content library and schedule it."))));
    }
  }]);

  return QueueWrap;
}(Component)) || _class);
export { QueueWrap as default };
QueueWrap.defaultProps = {
  showTabs: true
};